import { FormControl, Grid, Typography } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import Link from "@material-ui/core/Link";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import { red } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import dayjs from "dayjs";
import {
  AssignmentTurnedIn,
  CancelOutlined,
  CloudDownload,
  Delete,
  Edit,
  Input,
  PostAdd,
  Visibility,
  GetApp
} from "@material-ui/icons";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { AgGridReact } from "ag-grid-react";
import Moment from "moment";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import FileSaver from "file-saver";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { DatePicker } from "@mui/x-date-pickers";

import DeleteCellRenderer from "./deleteCellRenderer";
import { EXCEL_FILE_BASE64 } from "./excelTemplateConstant-DomesticFCL";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { renameColumns } from "../../utils/common";
import api from "../../utils/api";
const autoStyle = {
  fontSize: "0.8rem",
  width: "100%",
};
function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center" flexDirection="row">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}
LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};
const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 645,
    backgroundImage:
      "linear-gradient(to right, rgba(00, 92, 73,1), rgb(10, 36, 26))",
  },

  paperContainer1: {
    height: 356,
    minWidth: 900,
    backgroundImage: `linear-gradient(to right bottom, rgba(255,255,255,.1), rgba(255,255,255,.1)), url(${require("../../assets/img/Back_Projects_part1.png")})`,
    backgroundPosition: "0,0",
    backgroundColor: "#174C38",
    marginBottom: 20,
  },

  GridContainer: {
    minHeight: 356,
    margin: "0 2px",
    "@media screen and (max-width:576px)": {
      margin: "0",
    },
  },
  textSecondary: {
    color: "#ffffff",
  },
  paper: {
    position: "absolute",

    backgroundColor: "var(--neutralOffWhite)",
    border: "2px solid #000",
    boxShadow: "var(--neutralGray)",
    padding: "0px 25px 15px 30px",
  },
  smallWidth: {
    width: 400,
  },
  mediumWidth: {
    width: 1000,
  },
  largeWidth: {
    width: "90%",
    maxWidth: 1200,
  },
  textdata: {
    color: "#1164B4",
    fontSize: "14px",
    fontWeight: "bold",
  },
  height: {
    height: 600,
    overflow: "auto",
  },
  progressWidth: {
    width: 300,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "scroll",
  },
  paper1: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[9],
    padding: theme.spacing(2, 4, 3),
  },
  btn: {
    border: "1px solid #666",
    borderRadius: 0,
    padding: "15px 10px",
    marginBottom: "65px",
    textAlign: "center",
    cursor: "pointer",
  },
  media: {
    height: 50,
    paddingTop: "56.25%", // 16:9
  },
  avatar: {
    backgroundColor: red[500],
  },
  correctRow: {
    background: "white",
  },
  incorrectRow: {
    background: red[100],
  },
}));

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CNNDomesticFCL = () => {
  const classes = useStyles();
  const mounted = useRef(true);

  const gridRef = useRef();
  let gridApi = React.useRef(null);
  const APIBASE_URL = process.env.REACT_APP_APIBASE_URL;

  const [isLoadingCircle, setIsLoadingCircle] = useState(false);
  const [isLoadingBar, setIsLoadingBar] = useState(false);
  const [isSavingShipment, setIsSavingShipment] = useState(false);
  const MemberCode = useSelector((state) => state.memberreducer.MemberCode);
  const [dialogViewShipmentOpen, setDialogViewShipmentOpen] = useState(false);
  const [projectListDetails, setProjectListDetails] = useState([]);
  const [shipments, setShipments] = useState([]);
  const [nor40, setNor40] = useState(false);
  const navigate = useNavigate();
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [
    noncarbonNutralisedShipemntsDomestic,
    setNonCarbonNutralisedShipemntsDomestic,
  ] = useState([]);
  const [selectedIds, setSelectedIDs] = useState([]);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [emitionOffsetModalOpen, setEmitionOffsetModalOpen] = useState(false);
  const [OffsetSuccessModalOpen, setOffsetSuccessModalOpen] = useState(false);
  const [importSuccess, setImportSuccess] = useState(false);
  const [addShipmentSuccess, setAddShipmentSuccess] = useState(false);
  const [modalStyle] = React.useState(getModalStyle);
  const [availableAllOriginDestinations, setAvailableAllOriginDestinations] =
    useState([{}]);
  const [availableCarriers, setavailableCarriers] = useState([{}]);
  const [projChekbox, setProjChekbox] = useState([]);
  const [availableContSize] = useState([
    { Size: "20GP" },
    { Size: "40GP" },
    { Size: "40HC" },
    { Size: "45G1" },
    { Size: "22R1" },
    { Size: "40REHC" },
    { Size: "53FT" },
  ]);
  const [availableBlType] = useState([
    { type: "Domestic" },
  ]);
  const [availableTRansMode] = useState([
    { mode: "road", view: "Truck" },
    { mode: "rail", view: "Rail" },
    // { mode: "Barge" },
    // { mode: "sea" },
  ]);
  const [selectedPOLDate, setSelectedPOLDate] = React.useState(dayjs());

  const handleDateChange = (date) => {
    setSelectedPOLDate(date);
  };
  const CloseButton = ({ onClose }) => {
    return (
      <IconButton
        aria-label="close"
        color="primary"
        onClick={onClose}
        style={{ float: "right" }}
      >
        <CancelOutlined />
      </IconButton>
    );
  };
  const [state, setState] = useState({
    selectedCarrier: undefined,
    selectedOrigin: undefined,
    selectedDestination: undefined,
    selectedLoadPort: undefined,
    selectedDiscPort: undefined,
    selectedTransShpPort: undefined,
    selectedCyRamp: undefined,
    selectedPlaceofOrigin: undefined,
    originValue: "",
    loadPortValue: "",
    discPortValue: "",
    transShpPortValue: "",
    cyRampValue: "",
    destinationValue: "",
    originPlaceValue: "",
    carrierValue: "",
    dischargePlaceValue: "",
    fileName: "Choose Excel File to Import Shipments",
    selectedTrnsModeORGN: availableTRansMode[0],
    selectedTrnsModeLOAD: "",
    selectedTrnsModeDISC: "",
    selectedTrnsModeCYRAMP: "",
    selectedTrnsModeTRANS: "Truck",
    availableDestinations: [{}],
    availablePortofDischarge: [{}],
    availableCarriers: [{}],
    slectedBLType: availableBlType[0],
    containerNo: "",
    containerSize: availableContSize[2],
    vessel: "",
    voyage: "",
    Emission_Cacl_Basis: "Domestic",
    transShipvessel: "",
    comment1: "",
    comment2: "",
    comment3: "",
    totalCO2Emision: 0,
    isChecked: false,
    addShipmentAction: "ADD",
    shipmentIdToEdit: "",
    OriginAddress: "",
    OriginZIPCode: "",
    DestinationAddress: "",
    DestinationZIPCode: "",
  });

  const [selectedRows, setSelectedRows] = useState([]);
  const [errCR, setErrCR] = useState(false);
  const [errCntnr, setErrCntnr] = useState(false);
  const [errCntSz, setErrCntSz] = useState(false);
  const [errOrgn, setErrOrgn] = useState(false);
  const [errDest, setErrDest] = useState(false);
  const handleViweShipmentDialogClose = () => {
    setDialogViewShipmentOpen(false);
  };
  const handleOriginValueChange = (_, v) => {
    let text = v;
    if (typeof v === "object") {
      text = `${v.selectedOrigin.City +
        ", " +
        v.selectedOrigin.StateProvince +
        ", " +
        v.selectedOrigin.Country +
        "- [" +
        v.selectedOrigin.UNLocode +
        "]"
        }`;
    }
    setState((prev) => ({ ...prev, originValue: text }));
  };
  const handleLoadPortValueChange = (_, v) => {
    let text = v;
    if (typeof v === "object") {
      text = `${v.selectedOrigin.City +
        ", " +
        v.selectedOrigin.StateProvince +
        ", " +
        v.selectedOrigin.Country +
        "- [" +
        v.selectedOrigin.UNLocode +
        "]"
        }`;
    }
    setState((prev) => ({ ...prev, loadPortValue: text }));
  };
  const handleCyRampValueChange = (_, v) => {
    let text = v;
    if (typeof v === "object") {
      text = `${v.selectedCyRamp.City +
        ", " +
        v.selectedCyRamp.StateProvince +
        ", " +
        v.selectedCyRamp.Country +
        "- [" +
        v.selectedCyRamp.UNLocode +
        "]"
        }`;
    }
    setState((prev) => ({ ...prev, cyRampValue: text }));
  };
  const handleDestinationValueChange = (_, v) => {
    let text = v;
    if (typeof v === "object") {
      text = `${v.selectedOrigin.City +
        ", " +
        v.selectedOrigin.StateProvince +
        ", " +
        v.selectedOrigin.Country +
        "- [" +
        v.selectedOrigin.UNLocode +
        "]"
        }`;
    }
    setState((prev) => ({ ...prev, destinationValue: text }));
  };
  const handleEditRecord = (recordId) => {
    const dataToEdit = noncarbonNutralisedShipemntsDomestic.find(
      (el) => el.GR_SH_ID === recordId
    );
    const selectedCarrier = availableCarriers.find(
      (el) => el.Carrier === dataToEdit.Carrier
    );
    const selectedOrigin = availableAllOriginDestinations.find(
      (el) => el.UNLoCode === dataToEdit.OriginLocCode
    );
    const selectedDestination = availableAllOriginDestinations.find(
      (el) => el.UNLoCode === dataToEdit.DestLocCode
    );
    const selectedLoadPort = availableAllOriginDestinations.find(
      (el) => el.UNLoCode === dataToEdit.LoadPortLocCode
    );
    const selectedDiscPort = availableAllOriginDestinations.find(
      (el) => el.UNLoCode === dataToEdit.DischargePortLocCode
    );
    const selectedTransShpPort = availableAllOriginDestinations.find(
      (el) => el.UNLoCode === dataToEdit.TransPortLocCode
    );
    const selectedCyRamp = availableAllOriginDestinations.find(
      (el) => el.UNLoCode === dataToEdit.InlandCYRampCode
    );
    const originValue = dataToEdit.Origin;
    const loadPortValue = dataToEdit.LoadPort;
    const discPortValue = dataToEdit.DischargePort;
    const transShpPortValue = dataToEdit.TransPort;
    const cyRampValue = dataToEdit.InlandCYRamp;
    const destinationValue = dataToEdit.Destination;
    const carrierValue = dataToEdit.Carrier;
    const dischargePlaceValue = dataToEdit.DischargePort;
    const selectedTrnsModeORGN = availableTRansMode.find(
      (el) => el.mode === dataToEdit?.OriginToLoadPortTranMode
    );
    const selectedTrnsModeLOAD = availableTRansMode.find(
      (el) => el.mode === dataToEdit?.LoadPortToTransPortTranMode
    );
    const selectedTrnsModeDISC = availableTRansMode.find(
      (el) => el.mode === dataToEdit?.DischargePortToInlandRampTranMode
    );
    const selectedTrnsModeCYRAMP = availableTRansMode.find(
      (el) => el.mode === dataToEdit?.InlandRampToDestTranMode
    );
    const slectedBLType = availableBlType.find(
      (el) => el.type === dataToEdit?.BLType
    );
    const containerNo = dataToEdit.ContainerNo;

    let containerSize = null;
    if (dataToEdit.ContainerSize === "40NOR") {
      containerSize = { Size: "40REHC" };
      setNor40(true);
    } else {
      containerSize = availableContSize.find(
        (el) => el.Size === dataToEdit.ContainerSize
      );
      setNor40(false);
    }
    const vessel = dataToEdit.Vessel;
    const voyage = dataToEdit.Voyage;
    const transShipvessel = dataToEdit.TranshipVesselName;
    const comment1 = dataToEdit.Comment1;
    const comment2 = dataToEdit.Comment2;
    const comment3 = dataToEdit.Comment3;
    const OriginAddress = dataToEdit.OriginAddress;
    const OriginZIPCode = dataToEdit.OriginZIPcode;
    const DestinationAddress = dataToEdit.DestinationAddress;
    const DestinationZIPCode = dataToEdit.DestinationZIPcode;
    const selectedPOLDate = dataToEdit.POLDate;

    console.log(selectedPOLDate);
    setSelectedPOLDate(dayjs(selectedPOLDate));
    setState((prev) => ({
      ...prev,
      selectedCarrier,
      selectedOrigin,
      selectedDestination,
      selectedLoadPort,
      selectedDiscPort,
      selectedTransShpPort,
      selectedCyRamp,
      // selectedPlaceofOrigin: undefined,
      originValue,
      loadPortValue,
      discPortValue,
      transShpPortValue,
      cyRampValue,
      destinationValue,
      // originPlaceValue: "",
      carrierValue,
      dischargePlaceValue,
      selectedTrnsModeORGN,
      selectedTrnsModeLOAD,
      selectedTrnsModeCYRAMP,
      selectedTrnsModeDISC,
      selectedTrnsModeTRANS: { mode: "Truck" },
      slectedBLType,
      containerNo,
      containerSize,
      vessel,
      voyage,
      transShipvessel,
      Emission_Cacl_Basis: "Domestic",
      comment1,
      comment2,
      comment3,
      OriginAddress,
      OriginZIPCode,
      DestinationAddress,
      DestinationZIPCode,
      addShipmentAction: "Edit",
      shipmentIdToEdit: recordId,
    }));
    setExportModalOpen(true);
  };
  const editButton = (props) => {
    return (
      <Button onClick={() => handleEditRecord(props.value)}>
        <Edit />
      </Button>
    );
  };

  const [progress, setProgress] = React.useState(0);

  const viewShipemntDetails = () => {
    console.log(selectedRows);
    setDialogViewShipmentOpen(true);
  };
  const handlecomment = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };
  const onSelectOrigine = (e, value) => {
    setState({ ...state, selectedOrigin: value });
    setErrOrgn(false);
  };

  const onSelectLoadPort = (e, value) => {
    setState({ ...state, selectedLoadPort: value });
  };

  const onSelectCYRamp = (e, value) => {
    setState({ ...state, selectedCyRamp: value });
  };
  const onSelectDestination = (e, value) => {
    setState({ ...state, selectedDestination: value });
    setErrDest(false);
  };
  const getShipmentList = () => {
    return api
      .get(
        `${APIBASE_URL}/GreenShipmentLoadType?MemberCode=${MemberCode}&ShipmentType=N&LoadType=DMST`
      )
      .then((res) => {
        const carriers = res.data;
        const nwCrr = carriers.map((el) => {
          return {
            ...el,
            id: el.GR_SH_ID,
          };
        });
        const zeroEmsn = carriers.filter((el) => {
          return el.CO2Emission_in_grams === 0;
        });
        // handleZeroEmsnVal(zeroEmsn);
        const convertedArr = nwCrr.map((i) => {
          const originParts = [i.OriginAddress, i.Origin, i.OriginZIPcode].filter(Boolean);
          const destParts = [i.DestinationAddress, i.Destination, i.DestinationZIPcode].filter(Boolean);
          return {
            ...i,
            fullOriginAddress: originParts.length ? originParts.join(", ") : null,
            fullDestAddress: destParts.length ? destParts.join(", ") : null
          };
        });
        setNonCarbonNutralisedShipemntsDomestic(convertedArr);
      })
      .catch(() => {
        setNonCarbonNutralisedShipemntsDomestic([]);
      });
  };

  const handleZeroEmsnVal = (val) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    };
    val.forEach((res) => {
      api
        .post(
          `${APIBASE_URL}/GreenShipments?EditFlag=1&vType=DMST`,
          res,
          requestOptions
        )
        .then((resp) => {
          console.log(resp);
          if (resp.status === 200) {
            console.log("Shipment edited successfully!");

          }
        });
    });
  };
  const handleDownloadCNNS = () => {
    const dataToExport = selectedRows.length > 0 ? selectedRows : noncarbonNutralisedShipemntsDomestic;
    const newCNNDATA = renameColumns(dataToExport);
    var wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(newCNNDATA);

    XLSX.utils.book_append_sheet(wb, ws, "Carbon non-nuetralized Shipment");
    XLSX.writeFile(wb, "Carbon-non-nuetralized-ShipmentDetails.xlsx");
  };
  const handleDownloadReport = async () => {
    setIsLoadingBar(true);
    try {
      const shipmentIds = selectedRows.map((r) => r.GR_SH_ID).join(",");
      const endpoint = `${APIBASE_URL}/GreenShipmentReport?MemberCode=${MemberCode}&LoadType=DMST${shipmentIds ? `&ShipmentIds=${shipmentIds}` : ""}`;

      const res = await api.get(endpoint);

      const data = res.data;

      if (!Array.isArray(data) || data.length === 0) {
        setSuccMsg("No data available to download");
        handleClick();
        return;
      }

      const commentKeys = ["Comment1", "Comment2", "Comment3"];
      const reorderedData = data.map((row) => {
        const { Comment1, Comment2, Comment3, ...rest } = row;
        return { ...rest, Comment1, Comment2, Comment3 };
      });

      const ws = XLSX.utils.json_to_sheet(reorderedData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Domestic FCL Report");

      XLSX.writeFile(
        wb,
        `DomesticFCL_Shipment_Report_${getCurrentDateTimeString()}.xlsx`
      );

      setSuccMsg("Report downloaded successfully");
      handleClick();
    } catch (err) {
      console.error("Download report error:", err);
      setSuccMsg("Failed to download report");
      handleClick();
    } finally {
      setIsLoadingBar(false);
    }
  };

  const handleDownloadTemplate = () => {
    let sliceSize = 1024;
    let byteCharacters = atob(EXCEL_FILE_BASE64);

    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    let byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      let begin = sliceIndex * sliceSize;
      let end = Math.min(begin + sliceSize, bytesLength);
      let bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }

    FileSaver.saveAs(
      new Blob(byteArrays, { type: "application/vnd.ms-excel" }),
      "GreenablShipmentsImport-Template-CNNDomFCL.xlsx"
    );
  };

  useEffect(() => {
    api
      .get(
        `${APIBASE_URL}/greenMemberProject?MemberCode=${MemberCode}`
      )
      .then((res) => {
        if (mounted.current) {
          if (projectListDetails.length === 0) {
            const projDetails = res.data;
            setProjectListDetails(projDetails);
            var defaultValues = [];
            var idArray = [];
            setSelectedIDs([]);

            res.data.forEach((el) => {
              setSelectedIDs((prev) => [...prev, el.PId]);
              idArray.push(el.PId);
              defaultValues.push("true");
            });
            if (selectedIds.length === 0) {
              setSelectedIDs(idArray);
            }
            setProjChekbox(defaultValues);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [APIBASE_URL, MemberCode, selectedIds.length]);

  useEffect(() => {
    getShipmentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [MemberCode, addShipmentSuccess]);

  useEffect(() => {
    mounted.current = true;

    api
      .get(
        `${APIBASE_URL}/greenCarrierCode?MemberCode=${MemberCode}`
      )
      .then((res) => {
        if (mounted.current) {
          const carriers = res.data;
          setavailableCarriers(carriers);
        }
      })
      .catch(() => {
        setavailableCarriers([]);
      });

    return () => {
      mounted.current = false;
    };
  }, [APIBASE_URL, MemberCode]);

  useEffect(() => {
    mounted.current = true;
    api
      .get(`${APIBASE_URL}/GreenLocations?LocType=All`)
      .then((res) => {
        if (mounted.current) {
          const DestiPorts = res.data;
          setAvailableAllOriginDestinations(DestiPorts);
        }
      })
      .catch(() => {
        setAvailableAllOriginDestinations([]);
      });
    return () => {
      mounted.current = false;
    };
  }, [APIBASE_URL]);

  const gridReady = (params) => {
    gridApi.current = params.api;
    gridApi.current.sizeColumnsToFit();
  };

  const handleChangeChkbx = (event, pid, index) => {
    if (event.target.checked) {
      setSelectedIDs([...selectedIds, pid]);
    } else {
      setSelectedIDs((prev) => {
        return prev.filter((el) => el !== pid);
      });
    }
    const newState = [...projChekbox];
    newState[index] = event.target.checked;
    setProjChekbox(newState);
  };
  const handleSudoImport = () => {
    setImportSuccess(false);
    setIsLoadingBar(true);
    const CopyShipments = window.structuredClone(shipments);
    // Exclude rows where status is 'Exitsting'
    const filteredShipments = CopyShipments.filter((shipment) => {
      return shipment.CO2EmissionFlag !== "Y";
    });

    if (filteredShipments.length > 0) {
      const promises = filteredShipments.map(async (element, indx) => {
        element.MemberCode = MemberCode;
        element.LoadType = "DMST";
        element.NOR = "";
        delete element.GR_SH_ID;
        delete element.id;
        delete element.CO2Emission_in_grams;
        delete element.Emission_Cacl_Date;
        delete element.InsertDate;
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          onUploadProgress: (progressEvent) => {
            console.log(progressEvent);
            let progress = (indx / filteredShipments.length) * 100;
            setProgress(progress);
            console.log(progress);
          },
        };

        await api.post(
          `${APIBASE_URL}/GreenShipments?EditFlag=0&vType=DMST`,
          element,
          requestOptions
        );
      });

      Promise.allSettled(promises).then((result) => {
        const failedObjects = [];

        result.forEach((res) => {
          if (res.status === "fulfilled") {
            console.log("Shipment added successfully!");
          } else if (res.status === "rejected") {
            failedObjects.push(res);
          }
        });
        setShipments([]);
        setState({
          ...state,
          fileName: "Choose Excel File to Import Shipments",
        });

        setTimeout(function () {
          getShipmentList();
          alert(
            "Shipment added successfully! failed to add: " +
            failedObjects.length +
            " records"
          );
        }, 3000);
        setIsLoadingBar(false);
        getShipmentList();
        setProgress(0);
        setImportModalOpen(false);
      });
    } else {
      alert("No Valid Shipment to be added. Please import correct data!");
      setShipments([]);
      setState({ ...state, fileName: "Choose Excel File to Import Shipments" });
      setIsLoadingBar(false);
    }
  };

  function updateData() {
    console.log("updateData");
    getShipmentList();
  }

  function getCurrentDateTimeString() {
    const currentDate = new Date();
    const MM = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // add 1 to get 1-based month and pad with 0 if necessary
    const DD = currentDate.getDate().toString().padStart(2, "0"); // pad with 0 if necessary
    const YYYY = currentDate.getFullYear().toString();
    const HH = currentDate.getHours().toString().padStart(2, "0"); // pad with 0 if necessary
    const mm = currentDate.getMinutes().toString().padStart(2, "0"); // pad with 0 if necessary
    const SS = currentDate.getSeconds().toString().padStart(2, "0"); // pad with 0 if necessary
    const currentDateTime = `${MM}${DD}${YYYY}${HH}${mm}${SS}`;
    return currentDateTime;
  }

  const handleSudoImport2 = () => {
    setAddShipmentSuccess(false);
    const uniqueselectedIds = [...new Set(selectedIds)];
    const randomNumber = Math.floor(Math.random() * (5000 - 1000 + 1)) + 1000;
    const totProjSelected = uniqueselectedIds.length;
    const CO2 = state.totalCO2Emision / totProjSelected;

    var OffsetCertificateIdVal = 0;
    if (uniqueselectedIds.length > 0) {
      const crtIds = [];
      uniqueselectedIds.forEach((id, i) => {
        const CBody = {
          OffsetCertificateTransactionId:
            "GREENGLOBALTRAN/" +
            getCurrentDateTimeString() +
            "/" +
            randomNumber +
            "/" +
            uniqueselectedIds[i],
          ProjectID: uniqueselectedIds[i],
          MemberCode: MemberCode,
          CO2: CO2, //[TotalamountOFCO2/NoOfProjectsSelected]
        };
        const requestOptionsProj = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        };
        setTimeout(() => {
          api
            .post(
              `${APIBASE_URL}/GreenOffsetCertificate`,
              CBody,
              requestOptionsProj
            )
            .then((respC) => {
              if (respC.status === 200) {
                OffsetCertificateIdVal = respC?.data;
                crtIds.push(OffsetCertificateIdVal);
                //Shipments
                selectedRows.forEach((shrow) => {
                  const Body = {
                    GR_SH_ID: shrow.GR_SH_ID,
                    ContainerNo: shrow.ContainerNo,
                    ProjectID: uniqueselectedIds[i],
                    DistPercentage: 1 / totProjSelected, // [(1/NoOfProjectsSelected)*100]
                    MemberCode: MemberCode,
                    CO2: shrow?.CO2Emission_in_grams / totProjSelected, //[TotalamountOFCO2/NoOfProjectsSelected]
                    OffsetCertificateId: OffsetCertificateIdVal,
                  };
                  const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                  };
                  api
                    .post(
                      `${APIBASE_URL}/GreenOffsetShipment`,
                      Body,
                      requestOptions
                    )
                    .then((resp) => {
                      if (resp.status === 200) {
                        setEmitionOffsetModalOpen(false);
                        setOffsetSuccessModalOpen(true);
                        setAddShipmentSuccess(true);
                      } else {
                        setEmitionOffsetModalOpen(false);
                        const failedElement = {
                          MemberCode: MemberCode,
                          ContainerNo: shrow.ContainerNo,
                          SH_ID: shrow.GR_SH_ID,
                          ErrorNo: resp.status,
                          ErrorDesc: "carbon offset went wrong while adding",
                          ModuleName:
                            "CarbonNonNeutralizedShipments.js: Carbon Offset Certificate save",
                        };
                        const requestOptions = {
                          method: "POST",
                          headers: { "Content-Type": "application/json" },
                        };

                        api
                          .post(
                            `${APIBASE_URL}/GreenErrorLog`,
                            failedElement,
                            requestOptions
                          )
                          .then((res) => {
                            console.log(res);
                          });
                      }
                    });
                });
              } else {
                setEmitionOffsetModalOpen(false);
                const failedElement = {
                  MemberCode: MemberCode,
                  ContainerNo: "",
                  SH_ID: "",
                  ErrorNo: respC.status,
                  ErrorDesc: "Carbon Offset Certificate saving error",
                  ModuleName:
                    "CarbonNonNeutralizedShipments.js: Carbon Offset Certificate save",
                };
                const requestOptions = {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                };

                api
                  .post(
                    `${APIBASE_URL}/GreenErrorLog`,
                    failedElement,
                    requestOptions
                  )
                  .then((res) => {
                    console.log(res);
                  });
              }
            });
        }, 2000);
      });
    }
  };
  const handleImport = ($event) => {
    setIsLoadingCircle(true);
    const files = $event.target.files;

    setState({ ...state, fileName: files[0].name });
    setImportSuccess(true);

    function excelDateToMMDDYYYY(excelDate) {
      // Function to convert Excel date number to "mm/dd/yyyy" format
      const date = new Date(Date.UTC(1899, 11, 30));
      date.setDate(date.getDate() + excelDate);
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    }

    if (files.length) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const Key = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        Key.forEach((row) => {
          if (typeof row[20] === "number") {
            // Assuming date is in the third column
            row[20] = excelDateToMMDDYYYY(row[20]);
          }
        });
        const bodyData = JSON.stringify({ Key });
        const PostOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        };
        api
          .post(`${APIBASE_URL}/GreenShipments?Temp=4`, bodyData, PostOptions)
          .then((respEx) => {
            if (respEx.status === 200) {
              const shipmnts = respEx.data;
              const ImpShpments = shipmnts.map((el, i) => {
                return {
                  ...el,
                  id: i + 1,
                };
              });
              setShipments(ImpShpments);
              setIsLoadingCircle(false);
            } else {
              alert(
                "Wrong excel template choosen! Please choose the excel file with correct template!"
              );
            }
          });
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const GetRowClassImport = (params) => {
    const status = params.row?.CO2EmissionFlag;
    const classes = useStyles();

    if (status === "Y") {
      return classes.incorrectRow;
    } else {
      return classes.correctRow;
    }
  };
  const handleImpModalOpen = () => {
    navigate('/Shipment/DOMCNN/importShipmentDOMFCL');
  };
  const handleImpModalClose = () => {
    setImportModalOpen(false);
  };

  const handleExpModalOpen = () => {
    setExportModalOpen(true);
  };
  const handleExpModalClose = (e, reason) => {
    if (reason !== "backdropClick") {
      setExportModalOpen(false);
      clearForm();
    }
  };
  const handleEmitionOffsetModalOpen = () => {
    setEmitionOffsetModalOpen(true);
  };
  const handleEmitionOffsetModalClose = () => {
    setEmitionOffsetModalOpen(false);
  };
  const handleOffsetSuccessModalClose = () => {
    setOffsetSuccessModalOpen(false);
  };

  const handleOffsetCerticateModalOpen = () => {
    setOffsetSuccessModalOpen(false);
    localStorage.setItem("PageHeader", "Shipment/CN");
    navigate("/Shipment/CN");
  };

  const handleChangeNor40 = (event) => {
    setNor40(event.target.checked);
    console.log(event.target.checked);
  };

  const handleContainerNo = (e) => {
    setState({ ...state, containerNo: e.target.value });
    if (e.target.value !== "") {
      setErrCntnr(false);
    }
  };


  const onSelectionChanged = useCallback(() => {
    var selectedRows = gridRef.current.api.getSelectedRows();
    setSelectedRows(selectedRows);
    var totalCO2Emsn = 0;
    selectedRows.forEach(function (selectedRow, index) {
      totalCO2Emsn += selectedRow.CO2Emission_in_grams;
    });
    setState((prev) => ({ ...prev, totalCO2Emision: totalCO2Emsn }));
  }, []);

  const addShipment = () => {
    if (state.containerNo === "") {
      setErrCntnr(true);
      return;
    }
    if (state.containerSize.Size === "") {
      setErrCntSz(true);
      return;
    }
    if (state.selectedOrigin === undefined) {
      setErrOrgn(true);
      return;
    }
    if (state.selectedDestination === undefined) {
      setErrDest(true);
      return;
    }

    setAddShipmentSuccess(false);
    const shipmentObj = {
      MemberCode: MemberCode,
      Carrier:
        state.selectedCarrier !== undefined
          ? state.selectedCarrier?.Carrier
          : "",
      ContainerNo: state.containerNo,
      ContainerSize: nor40 ? "40NOR" : state.containerSize.Size,
      Vessel: "",
      Voyage: "",
      TranshipVesselName: "",
      VesselIMO: "",
      POLDate: selectedPOLDate,
      BLType: "Domestic",
      OriginLocCode: state.selectedOrigin?.UNLoCode,
      LoadPortLocCode:
        state.selectedLoadPort !== undefined
          ? state.selectedLoadPort?.UNLoCode
          : "",
      TransPortLocCode: "", //state.selectedTransShpPort?.UNLoCode,
      DischargePortLocCode:
        state.selectedDiscPort !== undefined
          ? state.selectedDiscPort?.UNLoCode
          : "",
      InlandCYRampCode:
        state.selectedCyRamp !== undefined
          ? state.selectedCyRamp?.UNLoCode
          : "",
      DestLocCode: state.selectedDestination?.UNLoCode,
      Origin:
        state.selectedOrigin?.City +
        ", " +
        state.selectedOrigin?.StateProvince +
        ", " +
        state.selectedOrigin?.Country,
      LoadPort:
        state.selectedLoadPort !== undefined
          ? state.selectedLoadPort
            ? state.selectedLoadPort?.City +
            ", " +
            state.selectedLoadPort?.Country
            : ""
          : "", // used for CY ramp 1
      TransPort: "", //state.selectedTransShpPort?.City + ", " + state.selectedTransShpPort?.Country,
      DischargePort:
        state.selectedDiscPort !== undefined
          ? state.selectedDiscPort?.City +
          ", " +
          state.selectedDiscPort?.Country
          : "",
      InlandCYRamp:
        state.selectedCyRamp !== undefined
          ? state.selectedCyRamp
            ? state.selectedCyRamp?.City + ", " + state.selectedCyRamp?.Country
            : ""
          : "", // used for CY ramp 2
      Destination:
        state.selectedDestination?.City +
        ", " +
        state.selectedDestination?.StateProvince +
        ", " +
        state.selectedDestination?.Country,
      OriginToLoadPortTranMode: state.selectedTrnsModeORGN?.mode,
      LoadPortToTransPortTranMode:
        state.selectedLoadPort !== undefined
          ? state.selectedTrnsModeLOAD?.mode
          : "",
      TransPortToDischargePortTranMode: "",
      DischargePortToInlandRampTranMode:
        state.selectedDiscPort !== undefined
          ? state.selectedTrnsModeDISC?.mode
          : "",
      InlandRampToDestTranMode:
        state.selectedCyRamp !== undefined
          ? state.selectedTrnsModeCYRAMP?.mode
          : "",
      CO2EmissionFlag: "N",
      SCAC: state.selectedCarrier ? state.selectedCarrier.SCAC : "",
      LoadType: "DMST",
      NoOfCartons: 0,
      TotalWeight: 0.0,
      TotalVolume: 0.0,
      NOR: "",
      BLNo: "",
      Emission_Cacl_Basis: "Domestic",
      Comment1: state.comment1,
      Comment2: state.comment2,
      Comment3: state.comment3,
      OriginAddress: state.OriginAddress,
      OriginZIPCode: state.OriginZIPCode,
      DestinationAddress: state.DestinationAddress,
      DestinationZIPCode: state.DestinationZIPCode,
    };
    AddShipmentAPICall(shipmentObj);
  };

  const AddShipmentAPICall = async (shipmentObj) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    };

    setIsSavingShipment(true);

    try {
      if (state.addShipmentAction === "ADD") {
        const resp = await api.post(
          `${APIBASE_URL}/GreenShipments?EditFlag=0&vType=DMST`,
          shipmentObj,
          requestOptions
        );

        if (resp.status === 200) {
          setSuccMsg("Shipment added successfully!");
          clearForm();
          handleClick();
          setAddShipmentSuccess(true);
          handleExpModalClose();
        } else {
          handleExpModalClose();
          const failedElement = {
            MemberCode: MemberCode,
            ContainerNo: "",
            SH_ID: "",
            ErrorNo: resp.status,
            ErrorDesc: "Something went wrong while Shipment was added",
            ModuleName: "UserorifileContent.js: edit shipment",
          };

          const res = await api.post(
            `${APIBASE_URL}/GreenErrorLog`,
            failedElement,
            requestOptions
          );
          console.log(res);
        }
      } else if (state.addShipmentAction === "Edit") {
        shipmentObj.GR_SH_ID = state.shipmentIdToEdit;
        const resp = await api.post(
          `${APIBASE_URL}/GreenShipments?EditFlag=1&vType=DMST`,
          shipmentObj,
          requestOptions
        );

        if (resp.status === 200) {
          setSuccMsg("Shipment edited successfully!");
          clearForm();
          handleClick();
          setAddShipmentSuccess(true);
          handleExpModalClose();
        } else {
          console.log("Something went wrong while Editing Shipment!");
          handleExpModalClose();
          const failedElement = {
            MemberCode: MemberCode,
            ContainerNo: "",
            SH_ID: "",
            ErrorNo: resp.status,
            ErrorDesc: "Something went wrong while Editing Shipment",
            ModuleName: "UserorifileContent.js: edit shipment",
          };

          const res = await api.post(
            `${APIBASE_URL}/GreenErrorLog`,
            failedElement,
            requestOptions
          );
          console.log(res);
        }
      }
    } catch (error) {
      console.error("Something went wrong while saving shipment!", error);
    } finally {
      setIsSavingShipment(false);
    }
  };

  const clearForm = () => {
    setState({
      ...state,
      selectedCarrier: undefined,
      selectedOrigin: undefined,
      selectedDestination: undefined,
      selectedLoadPort: undefined, // for CY ramp 1
      selectedDiscPort: undefined,
      selectedTransShpPort: undefined,
      selectedCyRamp: undefined, // for CY ramp 2
      selectedPlaceofOrigin: undefined,
      originValue: "",
      loadPortValue: "", // for CY ramp 1
      discPortValue: "",
      transShpPortValue: "",
      cyRampValue: "", // for CY ramp 2
      destinationValue: "",
      originPlaceValue: "",
      carrierValue: "",
      dischargePlaceValue: "",
      selectedTrnsModeORGN: availableTRansMode[0],
      selectedTrnsModeLOAD: availableTRansMode[0], // for CY ramp 1
      selectedTrnsModeDISC: "",
      selectedTrnsModeCYRAMP: availableTRansMode[0], // for CY ramp 2
      selectedTrnsModeTRANS: "",
      availableDestinations: [{}],
      availablePortofDischarge: "",
      // availableCarriers: [{}],
      slectedBLType: availableBlType[0],
      containerNo: "",
      containerSize: availableContSize[2],
      vessel: "",
      voyage: "",
      transShipvessel: "",
      // transMode: "",
      addShipmentAction: "ADD",
      shipmentIdToEdit: "",
      Emission_Cacl_Basis: "Domestic",
      comment1: "",
      comment2: "",
      comment3: "",
      OriginAddress: "",
      OriginZIPCode: "",
      DestinationAddress: "",
      DestinationZIPCode: "",
    });
    setNor40(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (emitionOffsetModalOpen) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [emitionOffsetModalOpen]);

  const columns = [
    {
      field: "ContainerNo",
      headerName: "Container #",
      width: 135,
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,
      headerCheckboxSelectionCurrentPageOnly: true,
      headerCheckboxSelectionFilteredOnly: true,
    },
    {
      field: "ContainerSize",
      headerName: "CNsize",
      width: 130,
    },
    {
      field: "fullOriginAddress",
      headerName: "Origin",
      width: 180,
    },
    {
      field: "fullDestAddress",
      headerName: "Destination",
      width: 180,
    },
    {
      field: "POLDate",
      headerName: "Shipment Date",
      width: 140,
      valueFormatter: (params) => {
        if (!params.value) return "";
        if (/^\d{4}-\d{2}-\d{2}$/.test(params.value)) {
          const [year, month, day] = params.value.split("-");
          return `${month}/${day}/${year}`;
        }
        const dt = new Date(params.value);
        return new Intl.DateTimeFormat("en-US").format(dt);
      },
    },
    {
      field: "CO2Emission_in_grams",
      headerName: "CO2e(MTon)",
      width: 175,
    },
    {
      field: "InsertDate",
      headerName: "Calc Date",
      width: 140,
      valueFormatter: (params) => {
        if (!params.value) return "";
        if (/^\d{4}-\d{2}-\d{2}$/.test(params.value)) {
          const [year, month, day] = params.value.split("-");
          return `${month}/${day}/${year}`;
        }
        const dt = new Date(params.value);
        return new Intl.DateTimeFormat("en-US").format(dt);
      },
    },
    {
      field: "Comment1",
      headerName: "Comment 1",
      width: 140,
    },
    {
      field: "Comment2",
      headerName: "Comment 2",
      width: 140,
    },
    {
      field: "Comment3",
      headerName: "Comment 3",
      width: 140,
    },
    {
      field: "GR_SH_ID",
      headerName: " ",

      cellRenderer: editButton,
      cellRendererParams: {
        update: updateData,
        setExportModalOpen,
        noncarbonNutralisedShipemntsDomestic,
        setSelectedPOLDate,
        setState,
        availableAllOriginDestinations,
        availableBlType,
        availableCarriers,
        availableContSize,
        availableTRansMode,
        //setTransShipments,
        setNor40,
      },
      pinned: "right",
      lockPosition: "left",
      width: 60,
    },
    {
      field: "GR_SH_ID",
      headerName: " ",
      cellRenderer: DeleteCellRenderer,
      cellRendererParams: {
        update: updateData,
        handleDeleteSuccess,
      },
      pinned: "right",
      lockPosition: "right",
      width: 60,
    },
  ];
  const datacolumns = [
    {
      field: "Carrier",
      headerName: "Carrier",
      width: 200,
      resizable: true,
    },
    {
      field: "BLType",
      headerName: "BLType",
      width: 160,
      resizable: true,
    },
    {
      field: "ContainerNo",
      headerName: "Container#",
      width: 180,
    },
    {
      field: "ContainerSize",
      headerName: "Size",
      width: 150,
    },

    {
      field: "OriginAddress",
      headerName: "Org Address",
      width: 260,
    },
    {
      field: "Origin",
      headerName: "Org City/State/Country",
      width: 260,
    },
    {
      field: "OriginZIPcode",
      headerName: "ZIP/PIN",
      width: 160,
    },
    {
      field: "OriginLocCode",
      headerName: "Origin LOCcode",
      width: 160,
    },

    {
      field: "LoadPort",
      headerName: "InlandCYRamp1",
      width: 160,
    },
    {
      field: "LoadPortLocCode",
      headerName: "InlandRamp LOCcode1",
      width: 160,
    },
    {
      field: "DischargePort",
      headerName: "InlandCYRamp2",
      width: 160,
    },
    {
      field: "DischargePortLocCode",
      headerName: "InlandRamp LOCcode2",
      width: 160,
    },
    {
      field: "DestinationAddress",
      headerName: "Destination Address",
      width: 260,
    },
    {
      field: "Destination",
      headerName: "Destination",
      width: 260,
    },
    {
      field: "DestinationZIPcode",
      headerName: "ZIP/PIN",
      width: 160,
    },
    {
      field: "DestLocCode",
      headerName: "Desti LOCcode",
      width: 160,
    },
    {
      field: "OriginToLoadPortTranMode",
      headerName: "Transportation Mode",
      width: 180,
    },
    {
      field: "POLDate",
      headerName: "Shipping Date",
      width: 150,
    },

    {
      field: "Comment1",
      headerName: "Comments 1",
      width: 350,
    },
    {
      field: "Comment2",
      headerName: "Comments 2",
      width: 350,
    },
    {
      field: "FailReason",
      headerName: "Comments",
      width: 350,
    }
  ];

  const [open, setOpen] = useState(false);
  const [succMsg, setSuccMsg] = useState("");

  const handleClick = () => {
    setOpen(true);
  };

  function handleDeleteSuccess(count = 1) {
    setSuccMsg(
      `${count} shipment${count > 1 ? "s" : ""} deleted successfully`
    );
    handleClick();
  }

  const handleCloseDelete = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setDeleteConfirmText(
      "Are you sure to delete multiple shipments at a time?"
    );
    setStatQuo("unconfirmed");
    setOpenDelete(false);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const onPageSizeChanged = useCallback(() => {
    var value = document.getElementById("page-size").value;
    gridRef.current.api.paginationSetPageSize(Number(value));
  }, []);

  const [deleteConfirmText, setDeleteConfirmText] = useState(
    "Are you sure to delete multiple shipments at a time?"
  );
  const [openDelete, setOpenDelete] = useState(false);
  const [statQuo, setStatQuo] = useState("unconfirmed");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const DeleteAllSelected = async (status) => {
    const selectedRows = gridRef.current?.api?.getSelectedRows?.() || [];

    if (status === "unconfirmed") {
      setStatQuo("semiconfirmed");
      setOpenDelete(true);
    } else if (status === "semiconfirmed") {
      setOpenDelete(false);
      const thisMany = selectedRows.length;
      setDeleteConfirmText(
        `Please confirm you are sure to delete ${thisMany} Shipments at one go? This action can not be undone.`
      );
      setStatQuo("confirmed");
      setOpenDelete(true);
    } else {
      const IdsToDelete = selectedRows.map((row) => row.GR_SH_ID);

      setOpenDelete(false);
      setStatQuo("unconfirmed");
      setDeleteConfirmText(
        "Are you sure to delete multiple shipments at a time?"
      );

      try {
        const resp = await api.post(`${APIBASE_URL}/deleteByShipmentIds`, {
          ShipmentIds: IdsToDelete,
        });

        let count = 0;
        if (Array.isArray(resp.data)) {
          count = Number(resp.data[0]) || 0;
        } else {
          count = Number(resp.data) || IdsToDelete.length;
        }

        if (resp.status === 200) {
          handleDeleteSuccess(count || IdsToDelete.length);
          updateData();
        }
      } catch (error) {
        console.error("Failed to delete selected shipments", error);
      }
    }
  };

  return (
    <>
      <Card className={classes.GridContainer}>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item sm={6} md={6} lg={6} sx={12}>
              <Typography variant="h5" style={{ display: "inline-block" }}>
                Carbon Non Neutralized Shipments - Domestic FCL
              </Typography>
              <Tooltip
                title="Download Excel Template"
                style={{ display: "inline-block" }}
              >
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={handleDownloadTemplate}
                  style={{ marginTop: 0, marginLeft: 14 }}
                >
                  <CloudDownload></CloudDownload>
                </Button>
              </Tooltip>
            </Grid>
            <Grid
              item
              sm={12}
              md={6}
              lg={6}
              sx={12}
              style={{ textAlign: "end" }}
            >
              <Tooltip title="Import Shipments">
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  style={{ margin: 7 }}
                  onClick={handleImpModalOpen}
                >
                  <Input></Input>
                </Button>
              </Tooltip>
              <Tooltip title="Add Shipment">
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  style={{ margin: 7 }}
                  onClick={handleExpModalOpen}
                >
                  <PostAdd></PostAdd>
                </Button>
              </Tooltip>
              <Tooltip title="Select and Offset Shipment">
                <span>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    style={{ margin: 7 }}
                    onClick={handleEmitionOffsetModalOpen}
                    disabled={selectedRows.length <= 0}
                  >
                    <AssignmentTurnedIn></AssignmentTurnedIn>
                  </Button>
                </span>
              </Tooltip>
              <Tooltip title="View Shipment">
                <span>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    style={{ margin: 7 }}
                    onClick={viewShipemntDetails}
                    disabled={selectedRows.length !== 1}
                  >
                    <Visibility></Visibility>
                  </Button>
                </span>
              </Tooltip>
              <Tooltip title="Download">
                <span>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={handleDownloadCNNS}
                    style={{ margin: 7 }}
                    disabled={
                      noncarbonNutralisedShipemntsDomestic.length === null
                    }
                  >
                    <SystemUpdateAltIcon></SystemUpdateAltIcon>
                  </Button>
                </span>
              </Tooltip>
              <Tooltip title="Detailed Download">
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  style={{ margin: 7 }}
                  onClick={handleDownloadReport}
                  disabled={noncarbonNutralisedShipemntsDomestic.length === 0}
                >
                  <GetApp />
                </Button>
              </Tooltip>
              <Tooltip title="Delete All">
                <span>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={() => DeleteAllSelected("unconfirmed")}
                    disabled={selectedRows.length <= 1}
                  >
                    <Delete></Delete>
                  </Button>
                </span>
              </Tooltip>
            </Grid>
          </Grid>
        </CardContent>

        <CardContent>
          <div className="example-header">
            Page Size:
            <select
              onChange={onPageSizeChanged}
              id="page-size"
              style={{ marginLeft: 10 }}
              defaultValue={50}
            >
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
          </div>
          <div
            style={{ height: 475, maxWidth: "100%", overflowX: "auto" }}
            className="ag-theme-alpine"
          >
            <AgGridReact
              ref={gridRef}
              columnDefs={columns}
              rowData={noncarbonNutralisedShipemntsDomestic}
              rowSelection={"multiple"}
              rowMultiSelectWithClick={true}
              onSelectionChanged={onSelectionChanged}
              defaultColDef={{
                resizable: true,
                sortable: true,
                background: "#f0f0f5",
                filter: "agTextColumnFilter",
              }}
              pagination={true}
              paginationPageSize={50}
              onGridReady={gridReady}
              onRowDoubleClicked={(params) => handleEditRecord(params.data.GR_SH_ID)}
            // frameworkComponents={{
            //   checkCellRendere: CheckRenderer,
            //   checkArrivalRenderer: arrivalNoticeStatus,
            // }}
            ></AgGridReact>
          </div>
        </CardContent>

        <>
          <Modal
            open={importModalOpen}
            onClose={handleImpModalClose}
            aria-labelledby="excel-import-modal"
            aria-describedby="excel-import-modal-description"
          >
            <div
              style={modalStyle}
              className={`${classes.paper} ${classes.largeWidth}`}
            >
              <h2 id="simple-modal-title" style={{ textAlignLast: "center" }}>
                Import Shipments
              </h2>
              <CardContent>
                <div style={{ height: 450, width: "100%" }}>
                  <div className="custom-file">
                    <label for="fileInput" className={classes.btn}>
                      {state.fileName}
                    </label>
                    <input
                      type="file"
                      name="file"
                      className="custom-file-input"
                      id="fileInput"
                      required
                      style={{ visibility: "hidden", paddingBottom: 15 }}
                      onChange={handleImport}
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    />
                    {isLoadingCircle && <CircularProgress color="secondary" />}
                  </div>

                  <DataGrid
                    rows={shipments}
                    columns={datacolumns}
                    getRowClassName={GetRowClassImport}
                    pageSize={10}
                    rowsPerPageOptions={[5]}
                    // checkboxSelection
                    disableSelectionOnClick
                  />
                </div>
              </CardContent>
              <CardContent
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 10,
                  marginTop: "16px",
                }}
              >
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={handleSudoImport}
                  style={{ width: 220, textTransform: "capitalize" }}
                  disabled={!importSuccess}
                >
                  Calculate Emission &amp; Add
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  style={{ width: 100, textTransform: "capitalize" }}
                  onClick={() => {
                    setImportModalOpen(false);
                    setShipments([]);
                    setState({
                      ...state,
                      fileName: "Choose Excel File to Import Shipments",
                    });
                    setIsLoadingCircle(false);
                    setIsLoadingBar(false);
                  }}
                >
                  Cancel
                </Button>
                {isLoadingBar && (
                  <LinearProgressWithLabel
                    value={progress}
                    className={classes.progressWidth}
                  />
                )}
              </CardContent>
            </div>
          </Modal>
          <div>
            <Dialog
              open={emitionOffsetModalOpen}
              onClose={handleEmitionOffsetModalClose}
              scroll="paper"
              aria-labelledby="scroll-dialog-title"
              aria-describedby="scroll-dialog-description"
              fullWidth={true}
              maxWidth={"lg"}
            >
              <DialogTitle id="scroll-dialog-title">
                Select Project(s) to get Carbon Credits
              </DialogTitle>
              {/* <CloseButton onClose={handleEmitionOffsetModalClose} /> */}
              <DialogContent dividers>
                <DialogContentText
                  id="scroll-dialog-description"
                  ref={descriptionElementRef}
                  tabIndex={-1}
                >
                  <Card>
                    <CardContent
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 8,
                        marginTop: "12px",
                      }}
                    >
                      <Grid
                        container
                        spacing={2}
                        style={{ paddingLeft: 20, paddingRight: 20 }}
                      >
                        {projectListDetails &&
                          projectListDetails.map((projDtls, index) => (
                            <Grid item sm={3} key={index}>
                              <Card
                                style={{
                                  minWidth: 130,
                                  maxWidth: 240,
                                  maxHeight: 540,
                                  minHeight: 370,
                                }}
                              >
                                <CardHeader
                                  style={{
                                    maxHeight: 115,
                                    minHeight: 100,
                                    verticalAlign: "top",
                                  }}
                                  title={projDtls.PName.substring(0, 35)}
                                  // subheader={projDtls.ProjectLocation.split(/[\s,]+/).pop()}
                                  subheader={projDtls.ProjectLocation.substring(
                                    projDtls.ProjectLocation.indexOf(",") + 1,
                                    100
                                  )}
                                  avatar={
                                    <Tooltip title={projDtls.PName}>
                                      <Avatar
                                        aria-label="recipe"
                                        className={classes.avatar}
                                      >
                                        {projDtls.PName[0]}
                                      </Avatar>
                                    </Tooltip>
                                  }
                                />

                                <CardMedia
                                  className={classes.media}
                                  image={projDtls.imgUrl}
                                />
                                <CardContent
                                  style={{
                                    maxHeight: 125,
                                    minHeight: 125,
                                  }}
                                >
                                  <Typography variant="body2">
                                    Total CO<sub>2</sub>e for Offset:{" "}
                                    {projDtls.PAvailable_carbon_in_kg} MTon
                                  </Typography>
                                  <Typography variant="body2">
                                    Offset Cost per MTon: $
                                    {(projDtls?.Pcost_per_kg_carbon_in_usd_cents *
                                      1000) /
                                      100}
                                  </Typography>
                                  <FormGroup
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignContent: "space-between",
                                    }}
                                  >
                                    <FormControlLabel
                                      key={projDtls.PId}
                                      control={
                                        <Checkbox
                                          checked={projChekbox[index]}
                                          onChange={(e) =>
                                            handleChangeChkbx(
                                              e,
                                              projDtls.PId,
                                              index
                                            )
                                          }
                                          name={projDtls.PId}
                                        />
                                      }
                                    />
                                  </FormGroup>
                                </CardContent>
                              </Card>
                            </Grid>
                          ))}
                      </Grid>

                      <div style={{ padding: "10px", textAlign: "center" }}>
                        <h3
                          id="simple-modal-title"
                          style={{ textAlignLast: "center" }}
                        >
                          Total CO<sub>2</sub>e for Offset:{" "}
                          {parseFloat(state.totalCO2Emision.toFixed(2))} MTon
                        </h3>
                        <Checkbox
                          checked={state.isChecked}
                          name="Agreement"
                          onClick={() =>
                            setState({
                              ...state,
                              isChecked: !state.isChecked,
                            })
                          }
                        />
                        This is to confirm that you are agreeing to recieve Carbon Credits for the
                        amount of carbon against the selected shipments.
                        <br />
                        <h4 style={{ textAlign: "center" }}>
                          Note: If multiple projects are selected, purchase will
                          be prorated by MTon(weight) among selected projects
                        </h4>
                      </div>
                      {/*  <h4>
            CO<sub>2</sub> Offsetting for selected shipments 60%
          </h4>
          <LinearProgressWithLabel
            value={progress}
            style={{ width: 250 }}
          /> */}
                    </CardContent>
                  </Card>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={handleSudoImport2}
                  style={{
                    width: 100,
                    textTransform: "capitalize",
                    marginRight: 15,
                  }}
                  disabled={!state.isChecked || selectedIds.length === 0}
                >
                  Proceed
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  style={{ width: 100, textTransform: "capitalize" }}
                  onClick={() => {
                    setEmitionOffsetModalOpen(false);
                  }}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          </div>

          <Modal
            open={OffsetSuccessModalOpen}
            onClose={handleOffsetSuccessModalClose}
            aria-labelledby="emition-offset-success-modal"
            aria-describedby="emition-offset-success-modal-description"
          >
            <div
              style={modalStyle}
              className={`${classes.paper} ${classes.largeWidth}`}
            >
              <h2 id="simple-modal-title" style={{ textAlignLast: "center" }}>
                Get Carbon Creadits for Shipments
              </h2>

              <CardContent
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 10,
                  marginTop: "16px",
                }}
              >
                <h2
                  id="transition-modal-description"
                  style={{ textAlign: "center" }}
                >
                  Congratulations!! You have successfully offset the amount of
                  carbon against the selected shipments!!
                </h2>
                <h2
                  id="transition-modal-description"
                  style={{ textAlign: "center" }}
                >
                  Click{" "}
                  <Link
                    href="#"
                    onClick={handleOffsetCerticateModalOpen}
                    style={{ color: "blue" }}
                  >
                    here{" "}
                  </Link>{" "}
                  to View and Download the Carbon Offset Certificates for the
                  Neutralized Shipments
                </h2>

                <h3 style={{ textAlign: "center" }}>
                  Note: Certificates can be download anytime from Greenabl web
                  application
                </h3>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  style={{ width: 100, textTransform: "capitalize" }}
                  onClick={handleOffsetSuccessModalClose}
                >
                  Okay
                </Button>
              </CardContent>
            </div>
          </Modal>
          <Modal
            open={exportModalOpen}
            onClose={(e, reason) => {
              handleExpModalClose(e, reason);
            }}
            aria-labelledby="shipment-export-modal"
            aria-describedby="shipment-export-modal-description"
          >
            <div
              style={modalStyle}
              className={`${classes.paper} ${classes.mediumWidth}`}
            >
              <h2 id="simple-modal-title">
                {state.addShipmentAction +
                  " Shipment Domestic FCL [Automated Emission Calculation]"}
              </h2>

              <Grid
                container
                spacing={3}
                style={{ border: "2px solid #f3edea" }}
              >
                <Grid item sm={12} lg={12} xl={12} style={{ padding: 8 }}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <FormControl>
                        <TextField
                          id="outlined-basic"
                          variant="outlined"
                          fullWidth
                          size="small"
                          style={{
                            display: "inline-flex",
                            backgroundColor: "#EDEAE8",
                            borderRadius: "4px",
                          }}
                          required
                          value={state.containerNo}
                          label="Container No"
                          inputProps={{ maxLength: 20 }}
                          onChange={handleContainerNo}
                          error={errCntnr}
                          helperText={
                            errCntnr ? "Container number can not be blank" : ""
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                      <Autocomplete
                        id="gem-contSize-select"
                        size="small"
                        fullWidth
                        disableClearable
                        options={availableContSize}
                        getOptionLabel={(option) => option.Size}
                        renderOption={(option) => (
                          <React.Fragment>{option.Size}</React.Fragment>
                        )}
                        value={state.containerSize}
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#f3edea",
                        }}
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Cont. Size"
                            variant="outlined"
                            required
                            error={errCntSz}
                            helperText={
                              errCntSz ? "Container size can not be blank" : ""
                            }
                          />
                        )}
                        onChange={(event, nwValue) => {
                          setState({ ...state, containerSize: nwValue });
                          if (nwValue.Size !== "40REHC") {
                            setNor40(false);
                          }
                          setErrCntSz(errCntSz ? !errCntSz : errCntSz);
                        }}
                        color="primay"
                        classes={{ option: classes.option }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={
                              state.containerSize?.Size === "40REHC"
                                ? false
                                : true
                            }
                            checked={nor40}
                            onChange={handleChangeNor40}
                            name="NOR"
                            style={{ marginLeft: -16, paddingRight: 0 }}
                          />
                        }
                        label="NOR"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Autocomplete
                        id="gem-carr-select"
                        size="small"
                        fullWidth
                        disableClearable
                        options={availableCarriers}
                        getOptionLabel={(option) =>
                          option?.Carrier + " - " + option?.SCAC
                        }
                        renderOption={(option) => (
                          <React.Fragment>
                            {option.Carrier + " - " + option.SCAC}
                          </React.Fragment>
                        )}
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#f3edea",
                        }}
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Carrier"
                            variant="outlined"
                          />
                        )}
                        value={state.selectedCarrier}
                        onChange={(event, nwValue) => {
                          setState({
                            ...state,
                            selectedCarrier: nwValue,
                          });
                          setErrCR(errCR ? !errCR : errCR);
                        }}
                        color="primay"
                        classes={{ option: classes.option }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                      <DatePicker
                        label="POL Date"
                        value={selectedPOLDate}
                        onChange={handleDateChange}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            sx: {
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "#f3edea", // use exact color from dropdown
                                "& fieldset": { borderColor: "#ccc" }, // match dropdown border
                                "&:hover fieldset": { borderColor: "#005c49" },
                                "&.Mui-focused fieldset": { borderColor: "#005c49" },
                              },
                              "& .MuiInputBase-input": {
                                color: "#005c49", // match text color
                              },
                            },
                          },
                        }}
                      />

                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <TextField
                        id="outlined-multiline-static"
                        label="Origin Address Line 1 & 2"
                        fullWidth
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#EDEAE8",
                          borderRadius: "4px",
                        }}
                        size="small"
                        variant="outlined"
                        value={state.OriginAddress}
                        name="OriginAddress"
                        onChange={handlecomment}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Autocomplete
                        id="gem-transMode-select"
                        size="small"
                        fullWidth
                        options={availableTRansMode}
                        getOptionLabel={(option) => option.view}
                        renderOption={(option) => (
                          <React.Fragment>{option.view}</React.Fragment>
                        )}
                        value={state.selectedTrnsModeORGN}
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#f3edea",
                        }}
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Transportaion Mode"
                            variant="outlined"
                          />
                        )}
                        onChange={(event, nwValue) => {
                          setState({
                            ...state,
                            selectedTrnsModeORGN: nwValue,
                          });
                        }}
                        color="primay"
                        classes={{ option: classes.option }}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        fullWidth
                        size="small"
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#EDEAE8",
                          borderRadius: "4px",
                        }}
                        label="ZIP/PIN Code"
                        inputProps={{ maxLength: 20 }}
                        value={state.OriginZIPCode}
                        name="OriginZIPCode"
                        onChange={handlecomment}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Autocomplete
                        id="gem-origin-select"
                        size="small"
                        disableClearable
                        options={availableAllOriginDestinations}
                        getOptionLabel={(option) =>
                          option?.City +
                          ", " +
                          option?.StateProvince +
                          ", " +
                          option?.Country +
                          "- [" +
                          option?.UNLoCode +
                          "]"
                        }
                        renderOption={(option) => (
                          <React.Fragment>
                            {option.City +
                              ", " +
                              option.StateProvince +
                              ", " +
                              option.Country +
                              "- [" +
                              option.UNLoCode +
                              "]"}
                          </React.Fragment>
                        )}
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#f3edea",
                        }}
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Origin City, State, Country"
                            variant="outlined"
                            required
                            error={errOrgn}
                            helperText={
                              errOrgn ? "Origin can not be blank" : ""
                            }
                          />
                        )}
                        fullWidth
                        onChange={onSelectOrigine}
                        color="primay"
                        value={state.selectedOrigin}
                        inputValue={state.originValue}
                        onInputChange={handleOriginValueChange}
                        classes={{ option: classes.option }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Autocomplete
                        id="gem-origin-select"
                        size="small"
                        disableClearable
                        options={availableAllOriginDestinations}
                        getOptionLabel={(option) =>
                          option?.City +
                          ", " +
                          option?.StateProvince +
                          ", " +
                          option?.Country +
                          "- [" +
                          option?.UNLoCode +
                          "]"
                        }
                        renderOption={(option) => (
                          <React.Fragment>
                            {option.City +
                              ", " +
                              option.StateProvince +
                              ", " +
                              option.Country +
                              "- [" +
                              option.UNLoCode +
                              "]"}
                          </React.Fragment>
                        )}
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#f3edea",
                        }}
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Inland CY/Ramp 1"
                            variant="outlined"
                          />
                        )}
                        fullWidth
                        onChange={onSelectLoadPort}
                        color="primay"
                        value={state.selectedLoadPort}
                        inputValue={state.loadPortValue}
                        onInputChange={handleLoadPortValueChange}
                        classes={{ option: classes.option }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Autocomplete
                        id="gem-transMode-select"
                        size="small"
                        fullWidth
                        options={availableTRansMode}
                        getOptionLabel={(option) => option.view}
                        renderOption={(option) => (
                          <React.Fragment>{option.view}</React.Fragment>
                        )}
                        value={state.selectedTrnsModeLOAD}
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#f3edea",
                        }}
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Transportaion Mode"
                            variant="outlined"
                          />
                        )}
                        onChange={(event, nwValue) => {
                          setState({
                            ...state,
                            selectedTrnsModeLOAD: nwValue,
                          });
                        }}
                        color="primay"
                        classes={{ option: classes.option }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Autocomplete
                        id="gem-origin-select"
                        size="small"
                        disableClearable
                        options={availableAllOriginDestinations}
                        getOptionLabel={(option) =>
                          option?.City +
                          ", " +
                          option?.StateProvince +
                          ", " +
                          option?.Country +
                          "- [" +
                          option?.UNLoCode +
                          "]"
                        }
                        renderOption={(option) => (
                          <React.Fragment>
                            {option.City +
                              ", " +
                              option.StateProvince +
                              ", " +
                              option.Country +
                              "- [" +
                              option.UNLoCode +
                              "]"}
                          </React.Fragment>
                        )}
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#f3edea",
                        }}
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Inland CY/Ramp 2"
                            variant="outlined"
                          />
                        )}
                        fullWidth
                        onChange={onSelectCYRamp}
                        color="primay"
                        value={state.selectedCyRamp}
                        inputValue={state.cyRampValue}
                        onInputChange={handleCyRampValueChange}
                        classes={{ option: classes.option }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Autocomplete
                        id="gem-transMode-select"
                        size="small"
                        fullWidth
                        options={availableTRansMode}
                        getOptionLabel={(option) => option.view}
                        renderOption={(option) => (
                          <React.Fragment>{option.view}</React.Fragment>
                        )}
                        value={state.selectedTrnsModeCYRAMP}
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#f3edea",
                        }}
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Transportaion Mode"
                            variant="outlined"
                          />
                        )}
                        onChange={(event, nwValue) => {
                          setState({
                            ...state,
                            selectedTrnsModeCYRAMP: nwValue,
                          });
                        }}
                        color="primay"
                        classes={{ option: classes.option }}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <TextField
                        id="outlined-multiline-static"
                        label="Destination Address Line 1 & 2"
                        size="small"
                        fullWidth
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#EDEAE8",
                          borderRadius: "4px",
                        }}
                        variant="outlined"
                        value={state.DestinationAddress}
                        name="DestinationAddress"
                        onChange={handlecomment}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item sm={4}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        fullWidth
                        size="small"
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#EDEAE8",
                          borderRadius: "4px",
                        }}
                        label="ZIP/PIN Code"
                        inputProps={{ maxLength: 20 }}
                        value={state.DestinationZIPCode}
                        name="DestinationZIPCode"
                        onChange={handlecomment}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={3}>
                    <Grid item sm={12} md={6} lg={6} xl={6}>
                      <Autocomplete
                        id="gem-FinalDestination-select"
                        size="small"
                        options={availableAllOriginDestinations}
                        getOptionLabel={(option) =>
                          option?.City +
                          ", " +
                          option?.StateProvince +
                          ", " +
                          option?.Country +
                          "- [" +
                          option?.UNLoCode +
                          "]"
                        }
                        renderOption={(option) => (
                          <React.Fragment>
                            {option.City +
                              ", " +
                              option.StateProvince +
                              ", " +
                              option.Country +
                              "- [" +
                              option.UNLoCode +
                              "]"}
                          </React.Fragment>
                        )}
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#f3edea",
                        }}
                        autoSelect={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Destination"
                            variant="outlined"
                            required
                            error={errDest}
                            helperText={
                              errDest ? "Destination can not be blank" : ""
                            }
                          />
                        )}
                        fullWidth
                        disableClearable
                        onChange={onSelectDestination}
                        color="primay"
                        value={state.selectedDestination}
                        inputValue={state.destinationValue}
                        onInputChange={handleDestinationValueChange}
                        classes={{ option: classes.option }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        fullWidth
                        size="small"
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#EDEAE8",
                          borderRadius: "4px",
                        }}
                        value={state.comment1}
                        label="Comment 1"
                        onChange={handlecomment}
                        name="comment1"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        fullWidth
                        size="small"
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#EDEAE8",
                          borderRadius: "4px",
                        }}
                        value={state.comment2}
                        label="Comment 2"
                        onChange={handlecomment}
                        name="comment2"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        fullWidth
                        size="small"
                        style={{
                          display: "inline-flex",
                          backgroundColor: "#EDEAE8",
                          borderRadius: "4px",
                        }}
                        value={state.comment3}
                        label="Comment 3"
                        onChange={handlecomment}
                        name="comment3"
                      />
                    </Grid>
                    * mandatory fields
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      gap: 10,
                    }}
                  >
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      style={{ marginLeft: "auto" }}
                      onClick={handleExpModalClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={addShipment}
                      disabled={isSavingShipment}
                      startIcon={
                        isSavingShipment ? (
                          <CircularProgress size={18} color="inherit" />
                        ) : null
                      }
                    >
                      {isSavingShipment
                        ? "Saving..."
                        : state.addShipmentAction + " Shipment"}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Modal>
        </>
        <Dialog
          open={dialogViewShipmentOpen}
          onClose={handleViweShipmentDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth={"lg"}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginRight: "20px",
            }}
          >
            <DialogTitle id="alert-dialog-title">
              {"Shipment Details - Domestic"}
            </DialogTitle>
            <CloseButton onClose={handleViweShipmentDialogClose} />
          </div>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Card style={{ marginBottom: 15 }}>
                <CardContent
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    overflowX: "auto",
                  }}
                >

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <span>Container#: </span>
                      <span className={`${classes.textdata}`}>
                        {" "}
                        {selectedRows[0]?.ContainerNo}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      Container Size:{" "}
                      <span className={`${classes.textdata}`}>
                        {" "}
                        {selectedRows[0]?.ContainerSize}
                      </span>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      BL Type:{" "}
                      <span className={`${classes.textdata}`}>
                        {" "}
                        {selectedRows[0]?.BLType}
                      </span>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      Carrier:{" "}
                      <span className={`${classes.textdata}`}>
                        {" "}
                        {selectedRows[0]?.Carrier}
                      </span>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      Origin:{" "}
                      <span className={`${classes.textdata}`}>
                        {" "}
                        {selectedRows[0]?.Origin}
                      </span>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      Transport Mode:{" "}
                      <span className={`${classes.textdata}`}>
                        {" "}
                        {selectedRows[0]?.TransPort}
                      </span>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      Inland CY/Ramp 1:
                      <span className={`${classes.textdata}`}>
                        {" "}
                        {selectedRows[0]?.DischargePort}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      Inland Trnsp Mode 1:{" "}
                      <span className={`${classes.textdata}`}>
                        {selectedRows[0]?.OriginToLoadPortTranMode}
                      </span>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      Inland CY/Ramp 2:{" "}
                      <span className={`${classes.textdata}`}>
                        {selectedRows[0]?.InlandCYRamp}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      Inland Trnsp Mode 2:{" "}
                      <span className={`${classes.textdata}`}>
                        {selectedRows[0]?.OriginToLoadPortTranMode}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      Destination:{" "}
                      <span className={`${classes.textdata}`}>
                        {" "}
                        {selectedRows[0]?.Destination}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      Total CO<sub>2</sub>e:{" "}
                      <span className={`${classes.textdata}`}>
                        {" "}
                        {selectedRows[0]?.CO2Emission_in_grams}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      Emission Calc Based on:{" "}
                      <span className={`${classes.textdata}`}>
                        {" "}
                        {selectedRows[0]?.Emission_Cacl_Basis}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      Emission calc Date:{" "}
                      <span className={`${classes.textdata}`}>
                        {" "}
                        {Moment(
                          selectedRows[0]?.InsertDate.split("T")[0]
                        ).format("MM/DD/YYYY")}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      Comment1:{" "}
                      <span className={`${classes.textdata}`}>
                        {selectedRows[0]?.Comment1}{" "}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      Comment2:{" "}
                      <span className={`${classes.textdata}`}>
                        {selectedRows[0]?.Comment2}{" "}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      Comment3:{" "}
                      <span className={`${classes.textdata}`}>
                        {selectedRows[0]?.Comment3}{" "}
                      </span>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Card>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          {succMsg}
        </Alert>
      </Snackbar>

      <Dialog
        fullScreen={fullScreen}
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Please confirm Delete action"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{deleteConfirmText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => DeleteAllSelected(statQuo)}
            color="primary"
            autoFocus
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CNNDomesticFCL;
